angular.module('kareo.ui.shared.directives.chrome-header.navigation2', [
  'api', 'kareo.ui.shared.modules.iframe-modal-service',
  'kareo.ui.shared.modules.data',
  'kareo.ui.shared.modules.featureSet',
  'kareo.ui.shared.modules.billingWorkflow'])
  .controller('NavigationCtrl2', ['$sce', '$scope', '$timeout', '$window',
    'ChromeHeaderUrlFor', 'featureSet', 'patients',
    function ($sce, $scope, $timeout, $window,
              UrlFor, featureSet, Patients) {
      var KEYBOARD__EVENT_DOWN_ARROW = 40;
      var KEYBOARD__EVENT_ENTER = 13;
      var KEYBOARD__EVENT_UP_ARROW = 38;

      $scope.searchText = void 0;
      $scope.patients = [];

      $scope.urlFor = UrlFor;

      $scope.focused = function () {
        $scope.patientSearchActive = true;
      };
      var hasClinicalFeatures = false;
      var hasPatientSearchAfterThreeChars = false;
      $scope.placeholderDOB = 'Start typing a patient name or DOB';
      featureSet.load().then((features) => {
        hasClinicalFeatures = featureSet.hasClinicalFeatures();
        hasPatientSearchAfterThreeChars = !!features['dark-feature.patient-search-3-chars'];
      });

      $scope.$watch('patientSearchActive', (active) => {
        if (!active) {
          $scope.currentIndex = -1;
        }
      });

      $scope.getPatientUrl = function (patientId) {
        if (hasClinicalFeatures) {
          return UrlFor.ehrFacesheet(patientId);
        }
          return UrlFor.ehrDemographics(patientId);
      };

      $scope.handleKeyEvents = function (event) {
        $scope.patientSearchActive = true;
        var keyCode = event.keyCode;
        if (!(keyCode === KEYBOARD__EVENT_ENTER || keyCode === KEYBOARD__EVENT_DOWN_ARROW || keyCode === KEYBOARD__EVENT_UP_ARROW)) {
          return;
        }
        if (keyCode === KEYBOARD__EVENT_ENTER) {
          enter($scope.currentIndex, $scope.patients);
        } else if (keyCode === KEYBOARD__EVENT_DOWN_ARROW) {
          $scope.currentIndex = down($scope.currentIndex, $scope.patients);
        } else if (keyCode === KEYBOARD__EVENT_UP_ARROW) {
          $scope.currentIndex = up($scope.currentIndex, $scope.patients);
        }
        event.preventDefault();
      };

      $scope.$watch('searchText', search);

      function down(currentIndex, patients) {
        if (currentIndex < patients.length) {
          return currentIndex + 1;
        }
        return currentIndex;
      }

      function up(currentIndex) {
        if (currentIndex > 0) {
          return currentIndex - 1;
        }
        return currentIndex;
      }

      function enter(currentIndex, patients) {
        if (currentIndex === patients.length) {
          $window.location.href = '/patient-mgmt-ui/';
        } else if (currentIndex >= 0) {
          $window.location.href = $scope.getPatientUrl(patients[currentIndex].patientId);
        }
      }

      function searchHighlight(str) {
        if (!$scope.searchText) {
          return '';
        }
        var terms = $scope.searchText.split(' ');
        for (var i = 0, t; i < terms.length; i++) {
          t = terms[i];
          if (!t) {
            continue;
          }
          var pattern = '/(^|[^</>]|\w|\s|$)(' + t + ')(^|\w|\s|[^</>]|$)/ig';
          var regEx = eval(pattern); // eslint-disable-line no-eval
          str = str.replace(regEx, '$1<b>$2</b>$3');
        }
        return str;
      }
      var searchPromise = null;

      function search(searchText) {
        function doSearch() {
          Patients.searchFullName(searchText)
            .then((results) => {
              if (searchText === $scope.searchText) {
                searchResults(results);
              }
            })
            .catch(() => {
              $scope.searchError = true;
            });
        }

        $scope.searchError = false;
        $scope.oneCharSearchError = false;
        $scope.invalidDateError = false;
        var charRegex = new RegExp(/^[a-zA-Z]/);
        var numberRegex = new RegExp(/^[0-9/\\-]+$/);
        var dateRegex = new RegExp(/^((0?[1-9]|1[0-2])[-\/](0?[1-9]|[12][0-9]|3[01])[-\/]((19|20)\d{2})|(0?[1-9]|1[0-2])(0?[1-9]|[12][0-9]|3[01])((19|20)\d{2}))$|^\d{8}$/);

        searchResults();
        
        if (searchPromise) {
          $timeout.cancel(searchPromise);
        }

        if (searchText) {
          if (charRegex.test(searchText) && searchText.length === 1) {
            $scope.oneCharSearchError = true;
            return;
          }
          if (numberRegex.test(searchText)) {
            if (!dateRegex.test(searchText)) {
              $scope.invalidDateError = true;
              return;
            }
          }
          if (hasPatientSearchAfterThreeChars){
            if (searchText.length >= 3){
                searchPromise = $timeout(doSearch, 350);
            }
          }
          else {
            searchPromise = $timeout(doSearch, 350);
          }
        }
      }

      function searchResults(results) {
        results = results || [];
        $scope.currentIndex = -1;
        $scope.patients = highlightResults(results);
        return results;
      }

      function highlightPatient(patient) {
        var numbers = new RegExp(/^[\d+\/]+/);
        var fullName = patient.lastName + ', ' + patient.firstName;
        var highlighted = !numbers.test($scope.searchText) ? searchHighlight(fullName) : fullName;
        highlighted += ', ' + patient.dob().format('DD MMM YYYY');
        patient._fullNameHighlighted = $sce.trustAsHtml(highlighted);
        return patient;
      }

      function highlightResults(results) {
        if (!results) { return null; }
        angular.forEach(results, highlightPatient);
        return results;
      }
    }]
  );
